import React, {useEffect, useRef, useState} from 'react';
import {Select} from './Select';
import {FieldProp} from '../../types';
import {DisplayOnly} from './DisplayOnly';

type WorkflowUserEnhancedProps = FieldProp & {};

const formatEmployeeOptionLabel = (option, size = 'normal', inControl = false) => {
    const containerClassNames = [
        'd-flex align-items-center employee-info-container',
        size === 'normal' && 'employee-info-normal',
        size === 'small' && 'employee-info-small',
        size === 'extra-small' && 'employee-info-extra-small',
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClassNames} key={option.value}>
            {option.profilePhoto &&
                <img src={option.profilePhoto}
                     className="img-thumbnail rounded-circle"
                     alt="Profile Photo"
                     style={inControl ? {width: '35px', height: '35px'} : {}}
                />
            }
            <div className="ml-2">
                {option.displayName && <strong className="d-block">{option.displayName}</strong>}
                <small className="d-block text-muted">{option.label}</small>
                {size === 'normal' && option.title && <small className="d-block text-muted">{option.title}</small>}
                {size === 'normal' && option.department &&
                    <small className="d-block text-muted">{option.department}</small>}
            </div>
        </div>
    );
}
export const baseControlVisualStyles = {
    control: (provided, state) => ({
        ...provided,
        boxShadow: 'none',
        borderColor: state.isFocused ? 'rgba(253, 10, 33, .5)' : provided.borderColor,
        '&:hover': {
            borderColor: 'rgba(253, 10, 33, .5)'
        },
        fontSize: '14px',
        minHeight: 'calc(1.5em + .75rem + 2px)',
    })
};
export const defaultSelectStyles = {
    ...baseControlVisualStyles,
    valueContainer: (provided, state) => ({
        ...provided,
        minHeight: '20px',
    }),
    input: (provided, state) => ({
        ...provided,
        margin: '0px',
    }),
    indicatorsContainer:
        (provided, state) => ({
            ...provided,
            minHeight: '20px',
        }),
    dropdownIndicator:
        (styles) => ({
            ...styles,
            paddingTop: 4,
            paddingBottom: 4,
        }),
    clearIndicator:
        (styles) => ({
            ...styles,
            paddingTop: 4,
            paddingBottom: 4,
        }),
}
export const employeeRichSelectStyles = (size = 'small') => {
    const getHeightForSize = (size) => {
        switch (size) {
            case 'extra-small':
                return '35px';
            case 'small':
                return '50px'
            case 'normal':
            default:
                return '70px';
        }
    };

    return {
        ...defaultSelectStyles,
        valueContainer:
            (provided, state) => ({
                ...provided,
                minHeight: state.hasValue ? getHeightForSize(size) : provided.height,
            })
    }
}

export const WorkflowUserEnhanced: React.FunctionComponent<WorkflowUserEnhancedProps> = ({
                                                                                             displayOnly,
                                                                                             value,
                                                                                             ...props
                                                                                         }): JSX.Element => {

        const [showDetailPanel, setShowDetailPanel] = useState<boolean>(false);
        const panelContainerRef = useRef();

        // override default etl config with custom values
        if (props.field?.flowCustomDisplayComponentConfig?.etlConfig) {
            props.field.etlConfig = {
                ...props.field.etlConfig,
                ...props.field?.flowCustomDisplayComponentConfig?.etlConfig
            }
        }

        useEffect(() => {
            function handleClickOutside(event: MouseEvent) {
                // @ts-ignore
                if (panelContainerRef?.current && !panelContainerRef.current.contains(event.target)) {
                    setShowDetailPanel(false);
                }
            }

            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [panelContainerRef]);

        return (
            <div style={{
                position: 'relative'
            }}
            >
                {displayOnly ?
                    <DisplayOnly>
                        <div style={{
                            cursor: 'pointer'
                        }}
                             onClick={() => setShowDetailPanel(true)}>
                            {value && value?.value && formatEmployeeOptionLabel(value, 'small')}
                        </div>
                    </DisplayOnly>
                    :
                    <Select {...props}
                            placeholder="Begin typing user email address"
                            formatOptionLabel={(option: any) => formatEmployeeOptionLabel(option, 'small', true)}
                            styles={employeeRichSelectStyles('small')}
                            value={value}
                    />
                }
                {/* TODO - formatOptionLabel used above is overridden in the Select component. Need to address.... */}

                {/* TODO - Update to UserInfo component */}

                {showDetailPanel &&
                    <div
                        ref={panelContainerRef}
                        style={{
                            position: 'absolute',
                            top: '-100px',
                            left: '75px',
                            border: '1px solid #ccc',
                            boxShadow: '5px 5px 10px #999',
                            width: '300px',
                            background: 'white',
                            padding: '.75rem',
                            zIndex: 1
                        }}>
                        <div className={'d-flex align-items-center'}>
                            {value.profilePhoto &&
                                <img src={value.profilePhoto}
                                     className="img-thumbnail rounded-circle"
                                     alt="Profile Photo"
                                     style={{
                                         width: '100px',
                                         height: '100px'
                                     }}
                                />
                            }
                            <div className="ml-2">
                                {value.displayName && <strong className="d-block">{value.displayName}</strong>}
                                <small className="d-block text-muted">{value.label}</small>
                                {value.title && <small className="d-block text-muted">{value.title}</small>}
                                {value.department && <small className="d-block text-muted">{value.department}</small>}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
;